
const IMG_BASE_URL = "https://images.prismic.io/snooze-discovery-dev";

export default {
  data: () => ({
    sizes: [
      {
        value: "Single",
        image: `${IMG_BASE_URL}/a0aafac4-4e07-4b0e-b906-959a081a43a2_Single.svg`,
      },
      {
        value: "King Single",
        image: `${IMG_BASE_URL}/94d7f5ee-bd83-4289-9064-d9e7782e2a1f_King Single.svg`,
      },
      {
        value: "Long Single",
        image: `${IMG_BASE_URL}/cb5ddaaa-4666-40a2-b752-ac164ae562de_Long Single.svg`,
      },
      {
        value: "Double",
        image: `${IMG_BASE_URL}/1a07cd4b-466b-43c8-8bee-8aa7d56cb63f_Double.svg`,
      },
      {
        value: "Queen",
        image: `${IMG_BASE_URL}/68aed538-289b-41f2-b31a-0c4abb360a62_Queen.svg`,
      },
      {
        value: "King",
        image: `${IMG_BASE_URL}/8af1eda7-5d6e-4de7-a765-66bced439961_King.svg`,
      },
      {
        value: "Super Single",
        image: `${IMG_BASE_URL}/5e2e1eac-cf38-4a42-98be-0841258f51c9_Super King.svg`,
      },
    ],
  }),
};
